// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProductBanner_banner___VCWE"};